import React from "react";
import { motion } from "framer-motion";
import InnerPageNav from "./InnerPageNav";
import Footer from "./Footer";

const Ecosystem = () => {
  return (
    <>
      <InnerPageNav />

      <section className="section wf-section mt-20 text-center faqwrap m-auto">
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: "easeOut", duration: 1 }}
          className="text-style-all-caps"
        >
          EXPLORE THE CLOUDAX ECOSYSTEM
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: "easeOut", duration: 1 }}
          className="heading-large globalheader1 aligncenter"
        >
          <span className="color-text-gradient">
            An integrated Web3 Ecosystem
          </span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ ease: "easeOut", duration: 1 }}
          className="text-medium opacity-90"
        >
          Cloudax is a collaborative enterprise and blockchain platform
          ecosystem for faith based and wholesome content
        </motion.p>

        <div className="content-wrapper align-center mt-28">
          <div className="gradient-border _16px-radius">
            <div className="quote-container">
              <img
                src="images/bisi.png"
                loading="lazy"
                alt="man wearing yellow beanie and glasses"
                className="quote-image large"
              />
              <div className="quote-content">
                <div className="text-large">
                  " Cloudax is the world first ever blockchain ecosystem where
                  faith based and wholesome content businesses can grow using
                  crypto. With over 5,000,000 Members in our network and
                  powerful integrated suite. Investors, businesses, and
                  individual can thrive in our ecosystem"
                </div>
                <div className="quotee">
                  <div className="font-weight-extra-bold-800">
                    Adebisi Osademe
                  </div>
                  <div className="text-small opacity-90">Co-founder</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="section with-background-video wf-section">
        <div className="max-width-medium-640px">
          <div className="content-block padded">
            <motion.h1
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="heading-xlarge"
            >
              Wallet
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="opacity-90"
            >
              Easy-to-use wallet built to protect your digital assets with
              industry-leading security mechanisms. It is designed to support
              thousands of tokens and store your crypto and NFTs safely. The
              Cloudax wallet is simple and user-friendly.
            </motion.p>
            <div className="button-group">
              <a href="#" target="_blank" className="button secondary w-button">
                <span className="secondary-button-text">Get Started</span>
              </a>
            </div>
          </div>
        </div>
        <div
          data-poster-url="images/walletbg.jpg"
          data-video-urls="#"
          data-autoplay="true"
          data-loop="true"
          data-wf-ignore="true"
          className="background-video w-background-video w-background-video-atom"
        >
          <video
            id="e5e7074b-9e12-8f5e-e28e-86fc48c01a47-video"
            autoPlay={true}
            muted={true}
            loop={true}
            style={{ backgroundImage: 'url("images/walletbg.jpg")' }}
            playsInline=""
            data-wf-ignore="true"
            data-object-fit="cover"
          >
            <source src="#" />
            <source src="#" />
          </video>
        </div>
      </div>

      <div id="metamask" className="section top wf-section">
        <div className="content-wrapper _2-column-grid">
          <div
            id="w-node-_387564a6-a7ba-d4d6-6484-11c9ba1512c5-a2718ffa"
            className="content-block"
          >
            <motion.h1
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="heading-xlarge"
            >
              NFT Marketplace
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-medium opacity-90"
            >
              A Native marketplace to serve as the secondary exchange of
              Non-Fungible Tokens launched within the Cloudax ecosystem. Cloudax
              NFT is a market for digital collectibles and artworks of all
              kinds. In this marketplace, users may purchase, sell, and search
              for unique digital content.
            </motion.p>
            <div className="button-group">
              <motion.a
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ ease: "easeOut", duration: 1 }}
                id=""
                href="#"
                target="_blank"
                className="button secondary w-button"
              >
                <span className="secondary-button-text large">Get Started</span>
              </motion.a>
            </div>
          </div>
          <div id="" className="image-block">
            <div
              id="w-node-_1fe40e74-6fc8-8525-b0c0-74d45bd249ec-d5719002"
              className="joinsectionflexInner"
            >
              <div className="_16px-radius">
                <img
                  src="images/nftng.png"
                  loading="lazy"
                  alt=""
                  className="large radius15"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="luunch" className="section top wf-section">
        <div className="content-wrapper _2-column-grid">
          <div id="" className="image-block">
            <div
              id="w-node-_1fe40e74-6fc8-8525-b0c0-74d45bd249ec-d5719002"
              className="joinsectionflexInner"
            >
              <div className="gradient-border _16px-radius">
                <img
                  src="images/luunch.jpg"
                  loading="lazy"
                  alt=""
                  className="large radius15"
                />
              </div>
            </div>
          </div>
          <div
            id="w-node-_387564a6-a7ba-d4d6-6484-11c9ba1512c5-a2718ffa"
            className="content-block"
          >
            <motion.h1
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="heading-xlarge"
            >
              Launchpad
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-medium opacity-90"
            >
              Top tier incubator for the next generation of user-friendly
              blockchain applications and products, especially one that promote,
              publish or offer faith-based and/or wholesome utility. The
              DEX-based Launchpad will allow investors to participate in early
              crypto projects before they are publicly listed.
            </motion.p>
            <div className="button-group">
              <motion.a
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ ease: "easeOut", duration: 1 }}
                id=""
                href="#"
                target="_blank"
                className="button secondary w-button"
              >
                <span className="secondary-button-text large">Get Started</span>
              </motion.a>
            </div>
          </div>
        </div>
      </div>

      <div id="xchange" className="section top wf-section">
        <div className="content-wrapper _2-column-grid">
          <div
            id="w-node-_387564a6-a7ba-d4d6-6484-11c9ba1512c5-a2718ffa"
            className="content-block"
          >
            <motion.h1
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="heading-xlarge"
            >
              Exchange
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-medium opacity-90"
            >
              Cloudax Deccentralized Exchange (DEX) will enable users trade
              cryptocurrencies with low transaction fees. It will be integrated
              with the Cloudax wallet. Users of the exchange will have the
              ability to earn interests by staking and lending their tokens.
            </motion.p>
            <div className="button-group">
              <motion.a
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ ease: "easeOut", duration: 1 }}
                id=""
                href="#"
                target="_blank"
                className="button secondary w-button"
              >
                <span className="secondary-button-text large">Get Started</span>
              </motion.a>
            </div>
          </div>
          <div id="" className="image-block">
            <div
              id="w-node-_1fe40e74-6fc8-8525-b0c0-74d45bd249ec-d5719002"
              className="joinsectionflexInner"
            >
              <div className="gradient-border _16px-radius">
                <img
                  src="images/xchange.jpg"
                  loading="lazy"
                  alt=""
                  className="large radius15"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="luunch" className="section top wf-section">
        <div className="content-wrapper _2-column-grid">
          <div id="" className="image-block">
            <div
              id="w-node-_1fe40e74-6fc8-8525-b0c0-74d45bd249ec-d5719002"
              className="joinsectionflexInner"
            >
              <div className="gradient-border _16px-radius">
                <img
                  src="images/commerce.jpg"
                  loading="lazy"
                  alt=""
                  className="large radius15"
                />
              </div>
            </div>
          </div>
          <div
            id="w-node-_387564a6-a7ba-d4d6-6484-11c9ba1512c5-a2718ffa"
            className="content-block"
          >
            <motion.h1
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="heading-xlarge"
            >
              E-commerce
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
              className="text-medium opacity-90"
            >
              Cloudax's E-commerce feature will serve as a bridge between
              physical items and digital assets. The CLDX tokens will be used to
              purchase everyday items thereby providing more liquidity for your
              favourite cryptocurrency.
            </motion.p>
            <div className="button-group">
              <motion.a
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ ease: "easeOut", duration: 1 }}
                id=""
                href="#"
                target="_blank"
                className="button secondary w-button"
              >
                <span className="secondary-button-text large">Get Started</span>
              </motion.a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Ecosystem;
